import { createFileRoute } from "@tanstack/react-router";
import { myStoresQuery, sellEligibilityQuery } from "@/api/queries/selling";
import { SellPage, SellPageSkeleton } from "@/pages/sell/SellPage";

// Signed out → /join, unclaimed → /welcome (the _authed guard), then eligibility and seller terms (M3).
export const Route = createFileRoute("/_app/_authed/sell/")({
  loader: async ({ context }) => {
    await Promise.all([
      context.queryClient.fetchQuery(sellEligibilityQuery()),
      context.queryClient.fetchQuery(myStoresQuery()),
    ]);
  },
  pendingComponent: SellPageSkeleton,
  component: SellPage,
});
